import { useMutation, useQuery } from 'react-query';
import { cloneDeep, isArray } from 'lodash';
import { getContacts, mutateContact, getCardholderContactId, checkMatchingContact } from '~/api/contacts';

export const useGetContactsApi = (excludedRoles?: string) => {
  const response = useQuery([], () => getContacts(excludedRoles), {});

  return response;
};

export const useGetCardholderContactID = (phoneNo?: string, email?: string) => {
  const response = useQuery<any>(['cardholderContactId', phoneNo, email], () => getCardholderContactId(phoneNo, email));

  return response;
};

export const useGetShareholderData = ({ existedData }: any) => {
  const response = useQuery(['Allcontacts'], () => getContacts(), {});

  const cloneDeepRes = cloneDeep(response?.data);
  const cloneDeepData = cloneDeep(existedData);
  if (!cloneDeepRes || !cloneDeepData) {
    return null;
  }
  const contactsMapping = cloneDeepRes?.map((item: any) => item?.contacts)?.flat();
  return Object.entries(cloneDeepData || {})?.reduce((acc: any, item: any) => {
    const [key, value] = item;
    const selectedUsersData = isArray(value)
      ? value?.map((item: any) => {
          const replacedItem = contactsMapping?.find((ele: any) => ele?.contactId === item?.data?.contactId);
          return {
            ...item,
            data: {
              ...item?.data,
              ...replacedItem,
            },
          };
        })
      : value;
    acc = {
      ...acc,
      [key]: selectedUsersData,
    };
    return acc;
  }, {});
};

export const useCheckMatchingContact = () => {
  return useMutation(checkMatchingContact, {
    onMutate() {},
    onSuccess() {},
    onSettled() {},
  });
};

export const useMutateContactsApi = () => {
  return useMutation(mutateContact, {
    onMutate() {
      console.log('Mutation');
    },
    onSuccess(res) {
      console.log('onSuccess..', res);
      // history.push(paths.cardHolder.completion);
    },
    onSettled() {
      console.log('onSettled');
    },
  });
};
